export default class Thumbnail {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$info = this.$el.find('.info');
		this.$site = this.$el.find('.site');
		this.tagsHeight = [40, 20];
		this.breakpoint = [599, 736];
		this.$taglist = this.$el.find('.taglist');
		this.$templates = {
			taglist: $('<div class="taglist"></div>'),
			arrow: $('<div class="arrow-wrapper"><div class="arrow"></div></div>')
		}
	}

	init() {
		this.tagsArrow();
		this.autoExpand();
	}

	checkMobile() {
		var isLandscape = window.matchMedia("(orientation: landscape)").matches;
		var breakpoint = isLandscape ? this.breakpoint[1] : this.breakpoint[0];
		return window.innerWidth <= breakpoint;
	}

	expand() {
		var taglistHeight = this.$taglist[0].scrollHeight;
		var isActive = this.$taglist.hasClass('is-active');
		var isMobile = this.checkMobile();
		var taglistMaxHeight = isMobile ? this.tagsHeight[0] : this.tagsHeight[1];
		var toHeight = isActive ? taglistMaxHeight : taglistHeight;

		this.$taglist.stop(true).animate({maxHeight: toHeight}, 400).toggleClass('is-active');
	}

	tagsArrow() {
		if (!this.$taglist) {
			return;
		}

		const isMobile = this.checkMobile();
		const taglistHeight = this.$taglist[0].scrollHeight;
		const taglistMaxHeight = isMobile ? this.tagsHeight[0] : this.tagsHeight[1];
		const isOverflow = taglistHeight > taglistMaxHeight;

		let $arrow = isOverflow ? this.$templates.arrow.clone() : this.$taglist.find('.arrow');

		if ($arrow.length === 0) {
			return;
		}
		if (!isOverflow) {
			$arrow.remove();
			return;
		}

		$arrow.on('click', this.expand.bind(this));

		this.$taglist.addClass('arrow-toggle');
		this.$taglist.append($arrow);
	}

	autoExpand() {
		if (!this.$taglist || !this.$taglist.hasClass('arrow-toggle')) {
			return;
		}
		var timeout;
		var self = this;
		//var autoOpened = false;
		var $arrow = this.$taglist.find('.arrow-wrapper');

		$arrow.on('mouseenter', function() {
			if (self.$taglist.hasClass('is-active')) {
				return;
			}

			timeout = setTimeout(function() {
				if (self.$taglist.hasClass('is-active')) {
					return;
				}

				self.expand();
				// autoOpened = true;
			}, 200)
		});
		this.$taglist.on('mouseleave', function() {
			clearTimeout(timeout);
			if (!self.$taglist.hasClass('is-active')) {
				return;
			}
			// if (!autoOpened)
			// return

			self.expand();
			// autoOpened = false;
		})
	}
}


// WEBPACK FOOTER //
// ./src/desktop/scripts/components/thumbnail.js